import script from "./serve.vue?vue&type=script&setup=true&lang=ts"
export * from "./serve.vue?vue&type=script&setup=true&lang=ts"

import "./serve.vue?vue&type=style&index=0&id=464b0004&scoped=true&lang=less"
import "./serve.vue?vue&type=style&index=1&id=464b0004&scoped=true&lang=less"

import exportComponent from "/Users/jizhengliang/Desktop/octopus/edu/educms-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-464b0004"]])

export default __exports__